var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 39.5431V44.3335C9.33337 46.9118 11.4217 49.0001 14 49.0001H42C44.5784 49.0001 46.6667 46.9118 46.6667 44.3335V25.0695",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 31.3763V11.6667C9.33337 9.08833 11.4217 7 14 7H42C44.5784 7 46.6667 9.08833 46.6667 11.6667V16.9027",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2068 32.5723C13.8014 34.167 13.8014 36.7524 12.2068 38.347C10.6121 39.9417 8.02669 39.9417 6.43207 38.347C4.83742 36.7524 4.83742 34.1669 6.43207 32.5723C8.02671 30.9777 10.6121 30.9777 12.2068 32.5723",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2144 34.9929C30.2144 32.7389 32.0414 30.9095 34.2977 30.9095C36.554 30.9095 38.381 32.7365 38.381 34.9929C38.381 37.2492 36.554 39.0762 34.2977 39.0762C32.0507 39.0855 30.2237 37.2725 30.2144 35.0255C30.2144 35.0139 30.2144 35.0045 30.2144 34.9929Z",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7926 18.0987C26.3872 19.6933 26.3872 22.2788 24.7926 23.8734C23.1979 25.468 20.6125 25.468 19.0179 23.8734C17.4232 22.2787 17.4232 19.6933 19.0179 18.0987C20.6125 16.504 23.198 16.504 24.7926 18.0987",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.568 18.0987C51.1626 19.6933 51.1626 22.2788 49.568 23.8734C47.9733 25.468 45.3879 25.468 43.7933 23.8734C42.1986 22.2787 42.1986 19.6933 43.7933 18.0987C45.3879 16.504 47.9733 16.504 49.568 18.0987",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8434 23.9166L37.0768 32.0133",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0868 32.4567L19.1335 23.9634",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5234 32.0134L24.6868 23.9634",
    stroke: "#323232",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.5e1acbd573f89d4097fc4062b9fba347.svg";
export { ForwardRef as ReactComponent };